import React from "react";
import { motion } from "framer-motion";
import { FaRegSmile, FaStar } from "react-icons/fa";

const ServicesPage: React.FC = () => {
  return (
    <section className="py-16 px-6 md:px-16 bg-white">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10">
        {/* Sol Taraf: Başlık ve Açıklama */}
        <div>
          <p className="text-red-500 font-semibold uppercase">Sunduğumuz Hizmetler</p>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-2">
            Kocabay Tur'in sağladığı <br /> kaliteli hizmetler!
          </h2>
          <p className="text-gray-600 mt-4">
            Kocabay Tur olarak müşteri memnuniyeti önceliklidir.
          </p>
        </div>

        {/* Sağ Taraf: Kartlar */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {/* 1. Kart - Kaliteli Hizmet */}
          <motion.div
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="bg-white shadow-lg p-6 rounded-lg text-center"
          >
            <FaStar className="text-red-500 text-4xl mx-auto" />
            <h3 className="text-xl font-semibold text-gray-900 mt-4">Kaliteli Hizmet</h3>
            <p className="text-gray-600 mt-2">
              Hizmetlerimizin temel taşı olan kaliteli hizmet ilkemiz her zaman geçerlidir.
            </p>
          </motion.div>

          {/* 2. Kart - Mutlu Müşteri */}
          <motion.div
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="bg-white shadow-lg p-6 rounded-lg text-center"
          >
            <FaRegSmile className="text-red-500 text-4xl mx-auto" />
            <h3 className="text-xl font-semibold text-gray-900 mt-4">Mutlu Müşteri</h3>
            <p className="text-gray-600 mt-2">
              Mutlu müşteri demek, işinde başarılı bir Kocabay Tur demektir.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ServicesPage;
